export default __webpack_public_path__ + "static/media/profile-pic.65dd1c50.png";